import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/custom.css";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config"; // ✅ NEW


function Login() {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const togglePassword = () => setShowPassword(!showPassword);
    const handleLogin = async (e) => {
    e.preventDefault();

    console.log("Sending email:", email);
    console.log("Sending password:", password);

    try {
        const res = await fetch(`${API_BASE_URL}/auth/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, password }),
            credentials: "include"
        });

        const data = await res.json();

        if (data.status === "success") {
            navigate("/home");
        } else {
            setError(data.message);
        }
    } catch (err) {
        setError("Invalid Email ID Or Password. Please try again.");
    }
};

useEffect(() => {
        document.title = "Login | Webyappy";
      }, []);

    return (
        <div style={styles.page}>
            <div style={styles.overlay}>
                <div style={styles.card}>
                    <div className="text-center mb-4">
                        <img src="/assets/logos/webyappy.png" alt="Webyappy" style={{ maxHeight: "30px" }} />
                    </div>

                    <form className="w-100" onSubmit={handleLogin}>

                        <div className="form-group mb-4">
                            <label className="font-weight-bold small mb-2 d-block">
                                Email ID <span className="text-danger">*</span>
                            </label>
                            <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-control shadow-sm"
                            required
                            placeholder="Enter your email"
                            />
                        </div>

                        <div className="form-group mb-4 position-relative">
                            <label className="font-weight-bold small mb-2 d-block">
                                Password <span className="text-danger">*</span>
                            </label>
                            <input
                            type={showPassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-control shadow-sm pr-5"
                            required
                            placeholder="Enter your password"
                            />
                            <i
                                className={`far ${showPassword ? "fa-eye-slash" : "fa-eye"} text-danger`}
                                onClick={togglePassword}
                                style={{
                                    position: "absolute",
                                    top: "38px",
                                    right: "15px",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                        {error && (
                            <div className="alert alert-danger small py-2 mb-3" role="alert">
                                {error}
                            </div>
                            )}
            
                        <div className="text-right mb-4">
                            <a href="/home/forgotpass" className="text-primary small" style={{ textDecoration: "underline" }}>
                                Forgot Password?
                            </a>
                        </div>

                        <button type="submit" className="btn btn-primary w-100 font-weight-bold">
                            Login
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

// 🔹 Inline styles
const styles = {
    page: {
        backgroundImage: 'url("/assets/media/files/bgimg.png")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        position: "relative",
    },
    overlay: {
        background: "rgba(255, 255, 255, 0.9)", // optional semi-transparent white overlay
        padding: "2rem",
        borderRadius: "10px",
        width: "100%",
        maxWidth: "400px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    },
    card: {
        width: "100%",
    },
    eyeIcon: {
        position: "absolute",
        right: "10px",
        top: "37px",
        cursor: "pointer",
    },
};

export default Login;
